import { RouteConfig } from 'vue-router';

export default (): RouteConfig[] => {
	return [
		{ path: 'collections', name: 'collection-home', component: () => import('@client/views/products/collections/CollectionHome.vue') },
		{ path: 'collections/:id', name: 'collection-details', component: () => import('@client/views/products/collections/CollectionDetails.vue') },
	];
};
